import { OfficeAnnualPlan } from "./annual-plan.model";

export enum UserAnnualPlanState {
  Active = "active",
  Inactive = "inactive",
}

export type UserDetails = {
  firstName: string;
  lastName: string;
  userId: string;
  userState: string;
  userType: string;
};

export type UserAnnualPlan = {
  userAnnualPlanId: string;
  stripeSubscriptionId: string;
  cancelledReason?: string;
  startDate?: string;
  renewalDate?: string;
  expirationDate?: string;
  officeAnnualPlan: OfficeAnnualPlan;
  userAnnualPlanState: UserAnnualPlanState;
  additionalMembers?: string;
  user: UserDetails;
  userAnnualPlanDate?: string;
  isEditable?: boolean;
};
